module.exports = __webpack_public_path__ + "static/media/class_job_010.f6f9e033.svg";